<template>
  <div class="course-list">
    <div v-if="loading">
      <van-loading />
    </div>
    <div v-else>
      <div v-if="productList.length > 0">
        <template v-if="layout === 'normal'">
          <div v-for="item in productList" :key="item.productType" class="direct-course">
            <van-card
              v-for="val in item.productList"
              :key="val.id"
              :title="val.name"
              @click="toDetails(val.id)"
            >
              <template slot="thumb">
                <div class="img">
                  <img :src="val.pic" alt="">
                </div>
              </template>
              <template slot="price">
                <span>¥{{ val.price.toFixed(2) }}</span>
              </template>
              <template v-if="[null, undefined].indexOf(val.originalPrice) === -1" slot="num">
                <span>¥{{ val.originalPrice.toFixed(2) }}</span>
              </template>
            </van-card>
          </div>
        </template>
        <template v-else>
          <div class="grid-wrapper" >
            <div v-for="item in productList.flatMap(value => value.productList)" :key="item.id" class="grid-item" @click="toDetails(item.id)">
              <div class="image-wrapper">
                <van-image
                  :src="item.pic"
                  width="100%"
                  height="100%"
                  fit="contain"
                />
              </div>
              <div class="title text-overflow">
                {{ item.name }}
              </div>
              <div class="price">
                {{ item.price.toFixed(2) }}
                <span v-if="[null, undefined].indexOf(item.originalPrice) === -1">
                  {{ item.originalPrice.toFixed(2) }}
                </span>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div v-else class="empty_course">
        <img :src="empty_img" >
        <p>很抱歉，暂时没有对应的课程</p>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex';
import { Card, Icon, Loading, Image as VanImage } from 'vant';
export default {
  name: 'CourseList',
  components: {
    [Card.name]: Card,
    [Icon.name]: Icon,
    [Loading.name]: Loading,
    [VanImage.name]: VanImage
  },
  filters: {
    filterNum(num) {
      return num === null ? null : num === 0 ? '0.00' : num.toFixed(2);
    }
  },
  props: {
    layout: {
      type: String,
      default: 'normal'
    },
    ctype: {
      type: Number,
      default: 0
    },
    gradeCode: {
      type: String,
      default: 'undefined'
    },
    loading: {
      type: Boolean,
      default: true
    },
    xsid: {
      type: String,
      default: ''
    },
    reload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: {},
      empty_img: require('@/assets/img/empty_course.png'),
      swiper_lazy: require('@/assets/img/course/swiper.png'),
      course_lazy: require('@/assets/img/course/course.png'),
      productList: []
    };
  },
  computed: {
    // ...mapGetters(['productList'])
  },
  watch: {
    // ctype(val, oldval) {
    //   if (this.gradeCode !== 0 || val !== 0) {
    //     this.$emit('changeLoading', true);
    //     this.getList();
    //   }
    // },
    // gradeCode(val, oldval) {
    //   if (this.ctype !== 0) {
    //     this.$emit('changeLoading', true);
    //     this.getList();
    //   }
    // },
    // productList() {
    //   this.$emit('changeLoading', false);
    // }
    // xsid(val, oldval) {
    //   this.$emit('changeLoading', true);
    //   this.getList();
    // }
  },
  created() {
    console.log('course course this.gradeCode', this.gradeCode);
    if (this.gradeCode !== 'undefined') {
      console.log(77887);
      this.$emit('changeLoading', true);
      this.getList();
    }
  },
  methods: {
    toDetails(id) {
      this.$router.push({ name: 'courseDetails', query: { id }});
    },
    // 首页展示的商品列表
    getList() {
      console.log('coming getlist');
      let params = {
        productCategoryId: this.ctype || '',
        suitedGrade: this.gradeCode || ''
      };
      this.$store.dispatch('GetProductList', params).then(res => {
        console.log(11111, res);
        if (res.code === 200) {
          this.productList = res.data;
          this.$emit('changeLoading', false);
        }
      });
    },
    toMore(title, productType) {
      this.$router.push({ name: 'courseMore', query: { title, productType, productCategoryId: this.ctype, suitedGrade: this.gradeCode }});
    }
  }
};
</script>

<style scoped lang="scss">
.course-list {
  padding: 48px 30px 55px;
  background: #fff;

  .grid-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    .grid-item {
      width: 332px;
      height: 496px;
      background: $white;
      border-radius: 10px;
      margin-bottom: 20px;
      position: relative;
      box-shadow: 0px 4px 20px 5px rgba(0,0,0,0.1);
      padding: 20px;
      display: flex;
      flex-direction: column;
      .image-wrapper {
        width: 292px;
        height: 292px;
      }
      .title {
        font-size: 28px;
        color: $text-primary;
        font-weight: 600;
        margin-top: 12px;
        margin-bottom: 20px;
      }
      .price {
        font-size: 32px;
        font-weight: 600;
        color: $price;
        span {
          text-decoration: line-through;
          color: $text-tertiary;
          font-size: 24px;
        }
      }
    }
  }

  .direct-course:not(:first-of-type) {
    margin-top: 40px;
  }

  .guide {
    .t-left {
      padding: 0 20px;
      color: lighten($dark-black, 15%);
      font-weight: bold;
      font-size: 32px;
    }

    .t-right {
      color: lighten($dark-black, 55%);
      font-size: 28px;
      padding: 0 20px;

      label {
        font-weight: normal;
      }
    }
  }

  .record-course {
    padding-top: 40px;
  }

  .van-card__bottom {
    width: 100%;
    height: 40px;
    position: relative;
    line-height: 40px;
    display: flex;
    align-items: end;
  }

  /deep/ .van-card__price {
    max-width: 63%;
    height: 40px;
    font-weight: bold;

    > span {
      display: inline-block;
      max-width: 100%;
      max-height: 100%;

      @extend %one-line-text-overflow ;
    }
  }

  /deep/ .van-card__origin-price {
    // max-width: 21%;
    height: 40px;
    line-height: 40px;
    font-size: 24px;

    @extend %one-line-text-overflow ;
  }

  /deep/ .van-card__num {
    display: flex;
    align-items: center;
    // max-width: 37%;
    height: 40px;
    // position: absolute;
    // right: 0;
    margin-left: 10px;
    text-decoration: line-through;

    @extend %one-line-text-overflow ;
  }

  /deep/ .van-card__thumb {
    width: 240px;
    height: 134.4px;
    margin-right: 20px;

    .img {
      width: 100%;
      height: 100%;
      display: block;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  /deep/ .van-loading {
    text-align: center;
    padding-top: 30px;
  }

  .empty_course {
    text-align: center;

    img {
      width: 500px;
      height: 320px;
      margin-top: 50px;
    }

    p {
      color: #b0b0b0;
      font-size: 28px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/course/course.vue